import { createSelector } from 'reselect';
import { selectCurrentTerm } from 'selectors/terms';
import { selectCurrentTermSections } from 'selectors/section';
import { selectHelpUrl } from 'selectors/customer';
import { selectUser } from 'selectors/current_user';
import { isConnected } from 'selectors/offline';
import { isInstructorInTerm } from 'selectors/current_user';

const currentPathSelector = ({
    routing: {
        locationBeforeTransitions: { pathname },
    },
}) => pathname;

export default createSelector(
    [
        selectCurrentTerm,
        selectCurrentTermSections,
        selectHelpUrl,
        selectUser,
        isConnected,
        currentPathSelector,
        isInstructorInTerm,
    ],
    (term, sections, helpUrl, user, isConnected, currentPath, isInstructor) => {
        return {
            currentPath,
            term,
            sections,
            helpUrl,
            user,
            isConnected,
            isInstructor,
        };
    }
);



// WEBPACK FOOTER //
// ./src/selectors/component_selectors/term_view_selector.js